import { Injectable } from '@angular/core';
import { InvoiceableItems, Item, PackageQuotationLineItem, TestQuotationLineItem } from 'src/app/shared/models/order-creation/favorite-invoicable-item.model';
import { Analysis, AnalysisType } from 'projects/dop-ordering/src/public-api';
import { OrderCommandService } from 'src/app/shared/data-service/order-command.service';
import { Observable } from 'rxjs';
import { OrderDataService } from 'src/app/shared/data-service/order-data.service';

@Injectable({
    providedIn: 'root'
})
export class FavoriteAnalysisService {

    constructor(
        private orderCommandService: OrderCommandService,
        private orderDataService: OrderDataService) { }

    saveFavorite(quotationCode: string, selectedFavAnalysis: InvoiceableItems) {
        this.orderCommandService.addOrUpdateFavoriteAnalysis(quotationCode, selectedFavAnalysis).subscribe();
    }

    removeFromFavorite(analysisList: Analysis[], selectedFavAnalysis: InvoiceableItems) {
        analysisList.forEach((analysis: Analysis) => {
            if (!analysis.isFavorite) {
                switch (analysis.analysisType) {
                    case AnalysisType.CustomerPackage:
                        selectedFavAnalysis.customerPackages =
                            selectedFavAnalysis.customerPackages.filter(x => x.code !== analysis.subgroupCode && x.code != analysis.eurodatKey);
                        break;
                    case AnalysisType.FullSubgroup:
                        selectedFavAnalysis.testQuotationLines =
                            selectedFavAnalysis.testQuotationLines.filter(x => x.testCode ? x.subGroupCode !== analysis.subgroupCode : x.subGroupCode !== analysis.eurodatKey);
                        selectedFavAnalysis.packageQuotationLines =
                            selectedFavAnalysis.packageQuotationLines.filter(x => x.packageCode? x.subGroupCode !== analysis.subgroupCode : x.subGroupCode !== analysis.eurodatKey);
                        selectedFavAnalysis.subGroups = selectedFavAnalysis.subGroups.filter(x => x !== analysis.subgroupCode && x !== analysis.eurodatKey);
                        break;
                    case AnalysisType.SubgroupWithPackage:
                        selectedFavAnalysis.packageQuotationLines =
                            selectedFavAnalysis.packageQuotationLines.filter(x => x.packageCode? x.packageCode !== analysis.packageCode : x.code !== analysis.eurodatKey);
                        selectedFavAnalysis.subGroups = selectedFavAnalysis.subGroups.filter(x => x !== analysis.subgroupCode);
                        break;
                    case AnalysisType.SubgroupWithTest:
                        selectedFavAnalysis.testQuotationLines =
                            selectedFavAnalysis.testQuotationLines.filter(x => x.testCode? x.testCode !== analysis.testCode : x.code !== analysis.eurodatKey);
                        selectedFavAnalysis.subGroups = selectedFavAnalysis.subGroups.filter(x => x !== analysis.subgroupCode);
                        break;
                    case AnalysisType.FreeQLPackage:
                        selectedFavAnalysis.packageQuotationLines =
                            selectedFavAnalysis.packageQuotationLines.filter(x => x.packageCode? x.packageCode !== analysis.packageCode : x.code !== analysis.eurodatKey);
                        break;
                    case AnalysisType.FreeQLTest:
                        selectedFavAnalysis.testQuotationLines =
                            selectedFavAnalysis.testQuotationLines.filter(x => x.testCode? x.testCode !== analysis.testCode : x.code !== analysis.eurodatKey);
                        break;
                }
            } else {
                this.addToFavorite(analysis, selectedFavAnalysis);
            }
        });
    }

    addToFavorite(analysis: Analysis, selectedFavAnalysis: InvoiceableItems) {
        switch (analysis.analysisType) {
            case AnalysisType.CustomerPackage:
                selectedFavAnalysis.customerPackages = selectedFavAnalysis.customerPackages ?? [];
                selectedFavAnalysis.customerPackages.push({ code: analysis.subgroupCode });
                break;

            case AnalysisType.FullSubgroup:
                selectedFavAnalysis.testQuotationLines =
                    selectedFavAnalysis.testQuotationLines.filter(x => x.testCode !== analysis.subgroupCode);
                selectedFavAnalysis.packageQuotationLines =
                    selectedFavAnalysis.packageQuotationLines.filter(x => x.packageCode !== analysis.subgroupCode);
                selectedFavAnalysis.subGroups = selectedFavAnalysis.subGroups ?? [];
                selectedFavAnalysis.subGroups.push(analysis.subgroupCode);
                break;

            case AnalysisType.SubgroupWithPackage:
            case AnalysisType.SubgroupWithTest:
            case AnalysisType.FreeQLPackage:
            case AnalysisType.FreeQLTest:
                selectedFavAnalysis.packageQuotationLines = selectedFavAnalysis.packageQuotationLines ?? [];
                selectedFavAnalysis.testQuotationLines = selectedFavAnalysis.testQuotationLines ?? [];
                if(analysis.testCode){
                    if(!selectedFavAnalysis.testQuotationLines.some(a => a.testCode === analysis.testCode)){
                        const testQuotationLineItem = new TestQuotationLineItem(analysis.testCode, analysis.subgroupCode);
                        selectedFavAnalysis.testQuotationLines.push(testQuotationLineItem);
                    }
                }
                else{
                    const packageQuotationLineItem = new PackageQuotationLineItem(analysis.packageCode, analysis.subgroupCode);
                    selectedFavAnalysis.packageQuotationLines.push(packageQuotationLineItem);
                }
                break;
        }
    }

    getFavAnalysis(quotationCode: string): Observable<InvoiceableItems> {
        return this.orderDataService.getFavoriteItems(quotationCode);
    }
}
